import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

var _dec, _class, _class2, _temp;

/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { FieldArray as ReactFieldArray } from '@rexlabs/react-forms';
import { styled, StyleSheet } from '@rexlabs/styling';
import Field from './form-field';
import { map, isFunction } from 'lodash';

var DefaultRemoveButton = function DefaultRemoveButton(_ref) {
  var remove = _ref.remove,
      index = _ref.index,
      rest = _objectWithoutProperties(_ref, ["remove", "index"]);

  return React.createElement("div", _extends({
    type: "button"
  }, rest, {
    onClick: function onClick() {
      remove(index);
    }
  }), "\xD7");
};

var DefaultAddButton = function DefaultAddButton(_ref2) {
  var push = _ref2.push,
      rest = _objectWithoutProperties(_ref2, ["push"]);

  return React.createElement("button", _extends({
    type: "button"
  }, rest, {
    onClick: function onClick() {
      push();
    }
  }), "Add new");
};

var defaultStyles = StyleSheet({
  field: {
    display: 'flex',
    flex: 1,
    alignItems: 'space-around',
    justifyContent: 'center'
  },
  removeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  addButton: {
    margin: '0.2rem'
  }
});
var FieldArray = (_dec = styled(defaultStyles), _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(FieldArray, _Component);

  function FieldArray() {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, FieldArray);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FieldArray)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

    _defineProperty(_assertThisInitialized(_this), "requiresReinitialise", true);

    _defineProperty(_assertThisInitialized(_this), "initialFields", null);

    return _this;
  }

  _createClass(FieldArray, [{
    key: "resetFields",
    value: function resetFields(fieldArrayProps, newFields) {
      var _context2,
          _this2 = this;

      _forEachInstanceProperty(_context2 = fieldArrayProps.fields).call(_context2, function () {
        fieldArrayProps.pop();
      });

      if (newFields) {
        _forEachInstanceProperty(newFields).call(newFields, function (field) {
          fieldArrayProps.push({
            initialValue: field
          });
        });
      } else {
        // HACK: this timeout is due to the form values not updating between the popping above and the pushing after the
        // timeout, which means the new values are kept instead of the initialValues we are setting here
        _setTimeout(function () {
          var _context3;

          return _forEachInstanceProperty(_context3 = _this2.initialFields).call(_context3, function (field) {
            fieldArrayProps.push(field);
          });
        }, 100);
      }

      if (newFields) {
        this.requiresReinitialise = true;
      }
    }
  }, {
    key: "isDirtyWrapper",
    value: function isDirtyWrapper(renderFunction) {
      var _this3 = this;

      return function (fieldArrayProps) {
        var _context4;

        if (_this3.requiresReinitialise) {
          _this3.initialFields = _.clone(fieldArrayProps.fields);
          _this3.requiresReinitialise = false;
        }

        fieldArrayProps.isDirty = !_.isEqual(_this3.initialFields, fieldArrayProps.fields);
        fieldArrayProps.resetFields = _bindInstanceProperty(_context4 = _this3.resetFields).call(_context4, _this3, fieldArrayProps);
        return renderFunction(fieldArrayProps);
      };
    }
  }, {
    key: "defaultRender",
    value: function defaultRender() {
      var _this$props = this.props,
          s = _this$props.styles,
          RemoveButton = _this$props.RemoveButton,
          AddButton = _this$props.AddButton;
      return function (_ref3) {
        var fields = _ref3.fields,
            push = _ref3.push,
            remove = _ref3.remove,
            getFieldProps = _ref3.getFieldProps;
        return React.createElement("div", s('container'), map(fields, function (field, index) {
          return React.createElement("div", _extends({}, s('field'), {
            key: field.id
          }), React.createElement(Field, getFieldProps(field, index)), React.createElement(RemoveButton, _extends({}, s('removeButton'), {
            index: index,
            remove: remove
          })));
        }), React.createElement(AddButton, _extends({}, s('addButton'), {
          push: push
        })));
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          render = _this$props2.render,
          children = _this$props2.children,
          useIsDirtyWrapper = _this$props2.useIsDirtyWrapper,
          rest = _objectWithoutProperties(_this$props2, ["render", "children", "useIsDirtyWrapper"]);

      if (useIsDirtyWrapper) {
        children = isFunction(children) && this.isDirtyWrapper(children);
        render = isFunction(render) && this.isDirtyWrapper(render);
      }

      return React.createElement(ReactFieldArray, rest, isFunction(children) ? children : isFunction(render) ? render : this.defaultRender());
    }
  }]);

  return FieldArray;
}(Component), _defineProperty(_class2, "propTypes", {
  name: PropTypes.string,
  label: PropTypes.string,
  isInlineLabel: PropTypes.bool,
  inputProps: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  Input: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  FieldLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  FieldError: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  RemoveButton: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  AddButton: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  render: PropTypes.func,
  useIsDirtyWrapper: PropTypes.bool
}), _defineProperty(_class2, "defaultProps", {
  isInlineLabel: false,
  Input: 'input',
  inputProps: {},
  FieldLabel: 'label',
  FieldError: 'div',
  RemoveButton: DefaultRemoveButton,
  AddButton: DefaultAddButton,
  useIsDirtyWrapper: false
}), _temp)) || _class) || _class);
export default FieldArray;